/**
 * @generated SignedSource<<06713b2a3a4f55f0392b7fff3c072c14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddEmailTemplateVariantInput = {
  htmlContent: string;
  id: string;
  language: string;
  preheader?: string | null | undefined;
  subject: string;
  textContent: string;
};
export type AddEmailTemplateVariantDialogMutation$variables = {
  input: AddEmailTemplateVariantInput;
};
export type AddEmailTemplateVariantDialogMutation$data = {
  readonly addEmailTemplateVariant: {
    readonly id: string;
    readonly primaryLanguage: string;
    readonly variants: ReadonlyArray<{
      readonly htmlContent: string | null | undefined;
      readonly language: string;
      readonly preheader: string | null | undefined;
      readonly subject: string | null | undefined;
      readonly textContent: string | null | undefined;
    }>;
  };
};
export type AddEmailTemplateVariantDialogMutation = {
  response: AddEmailTemplateVariantDialogMutation$data;
  variables: AddEmailTemplateVariantDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "addEmailTemplateVariant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryLanguage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailTemplateVariant",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preheader",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "htmlContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textContent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddEmailTemplateVariantDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddEmailTemplateVariantDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2ae721f4818e537a4f0cd4c081f8e544",
    "id": null,
    "metadata": {},
    "name": "AddEmailTemplateVariantDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddEmailTemplateVariantDialogMutation(\n  $input: AddEmailTemplateVariantInput!\n) {\n  addEmailTemplateVariant(input: $input) {\n    id\n    primaryLanguage\n    variants {\n      language\n      subject\n      preheader\n      htmlContent\n      textContent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "640241c075cbcfa2ff768470780306c3";

export default node;
